export default {
    methods: {
        _obtenerUsuarios() {
            this.cargando = true;
            this.$http.get("usuarios", this.$headers).then(
                res => {
                    this.cargando = false;
                    if (res.status === 401) {
                        this.$router.push("/login");
                    } else if (res.status === 200 && "usuarios" in res.body) {
                        this.usuarios = res.body.usuarios;
                    } else {
                        this._falloResponse(res);
                    }
                },
                err => this._falloResponse(err)
            );
        }
    }
}